// extracted by mini-css-extract-plugin
var _1 = "_customerManagementDeleteCustomerModal-module__action-button";
var _2 = "_customerManagementDeleteCustomerModal-module__loader";
export { _1 as "action-button", _2 as "loader" }
